import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import AddParent from './dialogs/AddParentDialog';
import { setListParent } from './actions/parentActions';


/**
 * Function to present the filters and search the pricing plans by the filters
 * @param {*} props
 * @returns
 */
function FilterParent(props) {
  const { classes } = props;
  const endpoint = 'http://127.0.0.1:8000/api';
  const [statusButtonAdd, setStatusButtonAdd] = useState(false);
  const dispatch = useDispatch();
 
  /**
  * Method to set the list pricing plans
  */
  const getAllParents = async() => {
    const response = await axios.get(endpoint+'/parents');
    dispatch(setListParent(response.data));
    return response.data;
  };
  /**
  * Methods for the add dialog
  */
  const insertParent = () => {
    setStatusButtonAdd(true);
  };
  const handleCloseButtonAdd = () => {
    setStatusButtonAdd(false);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllParents();  
  }, []);
  return (
    <div style={{textAlign:"left"}}>
          <Button  id="insertParent" variant="contained" style={{backgroundColor: "#ffdf40", color: "#FFFFFF"}} onClick={insertParent} >Ingresar Padre de Familia</Button>
          <AddParent openStatus={statusButtonAdd} onClosed= {handleCloseButtonAdd}/>
          <br/>  <br/>
        </div>
  );
}

FilterParent.propTypes = {
  dataParent: PropTypes.string,
};

FilterParent.defaultProps = {
  dataParent: "true"
};

export default FilterParent;
